import React from 'react';

export const Minus: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="0 0 16 2" {...props}>
    <path
      d="M15.375 0H.625a.625.625 0 100 1.25h14.75a.625.625 0 100-1.25z"
      fill="currentColor"
    />
  </svg>
);
